/* eslint-disable no-console */
import { isNotProductionEnvironment } from '@treneo/environments';

type LogLevel =
  | 'log'
  | 'warn'
  | 'error'
  | 'debug'
  | 'info'
  | 'trace'
  | 'table'
  | 'group'
  | 'groupEnd'
  | 'time'
  | 'timeEnd';

interface Logger {
  log: (...args: unknown[]) => void;
  warn: (...args: unknown[]) => void;
  error: (...args: unknown[]) => void;
  debug: (...args: unknown[]) => void;
  info: (...args: unknown[]) => void;
  trace: (...args: unknown[]) => void;
  table: (tabularData?: unknown) => void;
  group: (...label: unknown[]) => void;
  groupEnd: () => void;
  time: (label?: string) => void;
  timeEnd: (label?: string) => void;
}

const shouldLog = (level: LogLevel): boolean => {
  if (level === 'error') {
    return true;
  }

  return isNotProductionEnvironment();
};

const createLogger = (): Logger => {
  const logger: Logger = {
    log: (...args: unknown[]) => {
      if (shouldLog('log')) {
        console.log(...args);
      }
    },
    warn: (...args: unknown[]) => {
      if (shouldLog('warn')) {
        console.warn(...args);
      }
    },
    error: (...args: unknown[]) => {
      if (shouldLog('error')) {
        console.error(...args);
      }
    },
    debug: (...args: unknown[]) => {
      if (shouldLog('debug')) {
        console.debug(...args);
      }
    },
    info: (...args: unknown[]) => {
      if (shouldLog('info')) {
        console.info(...args);
      }
    },
    trace: (...args: unknown[]) => {
      if (shouldLog('trace')) {
        console.trace(...args);
      }
    },
    table: (tabularData?: unknown) => {
      if (shouldLog('table')) {
        console.table(tabularData);
      }
    },
    group: (...label: unknown[]) => {
      if (shouldLog('group')) {
        console.group(...label);
      }
    },
    groupEnd: () => {
      if (shouldLog('groupEnd')) {
        console.groupEnd();
      }
    },
    time: (label?: string) => {
      if (shouldLog('time')) {
        console.time(label);
      }
    },
    timeEnd: (label?: string) => {
      if (shouldLog('timeEnd')) {
        console.timeEnd(label);
      }
    }
  };

  return logger;
};

export const logger = createLogger();
